import { render, staticRenderFns } from "./DynamicallyColouredArrow.vue?vue&type=template&id=57a89481&scoped=true&"
import script from "./DynamicallyColouredArrow.vue?vue&type=script&lang=js&"
export * from "./DynamicallyColouredArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a89481",
  null
  
)

export default component.exports